import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { MACRO_MEDIA_BASE } from '../../_shared/data/media';
import { buildPillPair } from '../../_shared/pills/pill-pair';
import { buildDiscountValue } from '../../_shared/text/discount-value';
import { buildBenefitLabel } from '../../_shared/pills/benefit-label';
import { buildPaymentMethodText } from '../../_shared/text/payment-method-text';
import { buildLimitText } from '../../_shared/text/limit-text';
import { buildLegales } from '../../_shared/text/legales';
import { buildBackgroundImage } from '../../_shared/images/background-image';
import { buildBrandLogos } from '../../_shared/images/brand-logos';

export const macroAhorro1080x1920: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1920,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    buildBackgroundImage({ canvasWidth: 1080, canvasHeight: 1920 }),

    // Shape blanca
    {
      kind: 'svg-url',
      src: `${MACRO_MEDIA_BASE}/templates/macro-ahorro/shape.svg`,
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 996,
      targetWidth: 962,
      targetHeight: 1468
    },

    // Logo Macro
    {
      cropX: 0,
      cropY: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 167.8039,
      width: 8930,
      height: 3545,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.0383,
      scaleY: 0.0383,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${MACRO_MEDIA_BASE}/logos/logo-macro-blanco.png`,
      crossOrigin: null,
      filters: []
    },

    // simbolo %

    {
      fontSize: 77,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '%',
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 851.7046,
      top: 630.4484,
      width: 97.7724,
      height: 87.01,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    buildPillPair({
      left: { pieceId: 'category', text: 'GASTRONOMÍA', style: 'white-blue-stroke' },
      right: { pieceId: 'valid-days', text: 'Lunes a viernes', style: 'pink-white-text' },
      fontSize: 35,
      paddingX: 21.882,
      paddingY: 7.294,
      strokeWidth: 1.824,
      position: { left: 540, top: 490.3769, width: 632.4051, height: 54.7686 }
    }),

    buildDiscountValue({
      pieceId: 'discount-value',
      text: '20',
      fontSize: 530,
      position: { left: 540, top: 805, width: 641.7024, height: 610.2 }
    }),

    buildBenefitLabel({
      pieceId: 'benefit-label',
      text: 'de ahorro',
      fontSize: 33,
      position: { left: 780.0759, top: 778.1817 },
      paddingX: 27,
      paddingY: 15,
      borderRadius: 33
    }),

    buildPaymentMethodText({
      pieceId: 'payment-method-text',
      text: 'Con todas tus tarjetas de Crédito Macro',
      fontSize: 49,
      lineHeight: 0.96,
      textAlign: 'center',
      position: { left: 540, top: 1079.7707, width: 521.3817, height: 108.5252 }
    }),

    buildPillPair({
      groupPieceId: 'payment-method-highlight-pair',
      left: {
        pieceId: 'payment-method-highlight-left',
        text: 'Exclusivo con',
        style: 'white-blue-stroke',
        icon: 'modo-blue'
      },
      right: {
        pieceId: 'payment-method-highlight-right',
        text: 'desde App',
        style: 'blue-white-stroke',
        icon: 'icono-white'
      },
      fontSize: 31,
      position: { left: 540, top: 1200.2185, width: 500, height: 50 }
    }),

    buildLimitText({
      pieceId: 'limit-text',
      text: 'Tope $10.000 por cliente, por semana.',
      position: { left: 540, top: 1266.0273, width: 595, height: 31.64 }
    }),

    buildBrandLogos({
      position: { left: 540, top: 1500, width: 600, height: 250 }
    }),

    buildLegales({
      pieceId: 'legales',
      text: 'CARTERA CONSUMO',
      position: { left: 540, top: 1800.7773, width: 683, height: 30.51 }
    })
  ],
  background: 'transparent'
};
